<template>
  <vue-final-modal
    v-slot="{ close }"
    v-bind="$attrs"
    classes="modal-container"
    content-class="modal-content"
    v-on="$listeners"
    :click-to-close="false"
  >
    <div class="modal__content p-4 md:p-4 text-center">
      <div class="modal__title heading max-w-[438px] mx-auto md:!text-2xl text-dark leading-11 text-left mb-2">
        {{ $t('modal.top-up-with-reward.title') }}
      </div>
      <div v-if="REWARD_BALANCE" class="max-w-[438px] mx-auto mt-[20px] mb-[20px] text-left text-lg font-semibold text-dark">
        {{ $t("profile.reward-balance-with-colon") }} ${{ REWARD_BALANCE }}
      </div>
      <div class="flex flex-col max-w-[438px] mx-auto gap-y-2 mb-[20px] text-left text-lg font-semibold text-dark">
        <label>{{ $t('modal.top-up-with-reward.choose-option') }}</label>
        <div v-for="option in options" :key="option">
          <input type="radio" :class="[
            'mr-2',
            { disabled: redemptionOptionDisabled(option) }
          ]" :id="option" name="amount" :value="option" v-model="amount" :disabled="redemptionOptionDisabled(option)">
          <label :for="option">{{ option }}</label>
        </div>
      </div>
      <div class="modal__action">
        <button
          type="button"
          class="btn btn-fixed-width btn-light"
          @click="close"
        >{{ $t('button.cancel') }}</button>
        <button
          type="button"
          :class="['btn btn-fixed-width', { disabled: confirmDisabled }]"
          :disabled="confirmDisabled"
          @click="topupWithReward"
        >{{ $t('button.confirm') }}</button>
      </div>
    </div>
    <button class="modal__close" @click="close">
      <icon-close-popup />
    </button>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from 'vue-final-modal'
import { mapGetters } from 'vuex'
import {
  getRedeemableOptions,
  topupWithReward
} from '@/utils/api/card'
import Big from 'big.js'

export default {
  components: { VueFinalModal },
  name: 'AddCardConfirm',
  inheritAttrs: false,
  data () {
    return {
      options: [],
      amount: '',
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('CARD', ['CURRENT_ID', 'REWARD_BALANCE']),
    confirmDisabled () {
      return !this.amount || this.isLoading
    },
    redemptionOptionDisabled () {
      return (option) => {
        return Big(this.REWARD_BALANCE).lt(option)
      }
    }
  },
  mounted () {
    this.getOptions()
    this.$store.dispatch('CARD/GET_REWARD_BALANCE')
  },
  methods: {
    async getOptions () {
      this.isLoading = true
      try {
        const { options } = await getRedeemableOptions()
        this.options = options
      } catch (e) {
        this.$store.dispatch('MODAL/CLOSE')
      } finally {
        this.isLoading = false
      }
    },
    async topupWithReward () {
      this.isLoading = true
      try {
        const data = {
          amount: this.amount
        }
        await topupWithReward(this.CURRENT_ID, data)
        this.$store.dispatch('MODAL/CLOSE')
        // refresh
        this.$store.dispatch('CARD/GET_CARD')
      } catch (e) {
        const error = e.response.data.message
        this.$store.dispatch('MODAL/ALERT', {
          title: this.$t('card.top-up-with-reward.alert.error-title'),
          text: error,
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
button {
  &.disabled {
    @apply cursor-not-allowed;
    // @apply opacity-25;
  }
}
.modal__action {
  @apply flex flex-col-reverse sm:flex-row gap-2;
  @apply mb-2;
}
</style>
